import { HintType } from '@hb/domain';
import { ButtonKey, QuestionKey } from '@hb/modules/global/global.constants';
import { AdditionalInfoComponent } from '@hb/modules';

import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApAnalyticsModule } from '@ap/analytics';
import { ApContentModule } from '@ap/content';
import { ApErrorModule } from '@ap/error';
import { ApAmountDisplayComponent } from '@ap/amounts';

@Component({
    selector: 'calculation-details-field',
    templateUrl: './calculation-details-field.component.html',
    styleUrls: ['./calculation-details-field.component.scss', '../../../global/global.scss'],
    standalone: true,
    imports: [ApAnalyticsModule, ApContentModule, ApErrorModule, CommonModule, ApAmountDisplayComponent, AdditionalInfoComponent]
})
export class CalculationDetailsFieldComponent {
    protected readonly hintType = HintType;

    @Input() key: QuestionKey | ButtonKey;
    @Input() amount: number;
    @Input() label: string;
    @Input() isSubTotal = false;
    @Input() totalRow = false;
    @Input() originalAmount?: number;
    @Input() additionalInfo = false;
    @Input() additionalInfoParam: { [p: string]: string } = undefined;

    id(): string {
        return this.label ? this.label?.slice(this.label?.lastIndexOf('.') + 1) : '';
    }
}
